module.exports = __webpack_public_path__ + "static/media/search_competitive_research.734fab54.png";